/* Blue Mountain Farm — cart page "You might also like" quick-add row.
   Suggests only items that ship free (Self-Care, Pantry, Clean collections), ordered by
   Shopify's related-product recommendations for what's in the cart, then filled from those collections. */
(function () {
  if (customElements.get('bmf-cart-upsell')) return;
  var POOL_COLLECTIONS = ['self-care-with-superpowers', 'pantry', 'clean'];
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (!document.getElementById('bmf-up-ux')) {
    var st = document.createElement('style'); st.id = 'bmf-up-ux';
    st.textContent = '.bmf-up__h{display:flex;align-items:baseline;justify-content:space-between;gap:1rem}.bmf-up__hint{display:none;font-size:1.2rem;font-weight:400;opacity:.7;letter-spacing:.02em;white-space:nowrap}@media screen and (max-width:749px){.bmf-up__hint{display:inline}}.bmf-up__add.is-added{background:#3f7d4e!important;border-color:#3f7d4e!important;color:#fff!important}';
    document.head.appendChild(st);
  }
  function added(btn) { btn.classList.add('is-added'); btn.textContent = 'Added \u2713'; return new Promise(function (r) { setTimeout(r, 800); }); }

  function getPool() {
    if (!window.__bmfUpPool) {
      window.__bmfUpPool = Promise.all(POOL_COLLECTIONS.map(function (h) {
        return fetch(root + 'collections/' + h + '/products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
      })).then(function (lists) {
        var seen = {}, out = [];
        lists.forEach(function (l) { (l.products || []).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } }); });
        return out;
      });
    }
    return window.__bmfUpPool;
  }
  function getRecs(ids) {
    return Promise.all(ids.slice(0, 3).map(function (id) {
      return fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
    })).then(function (lists) {
      var order = [];
      lists.forEach(function (l) { (l.products || []).forEach(function (p) { if (order.indexOf(p.id) < 0) order.push(p.id); }); });
      return order;
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(p) {
    var src = p.images && p.images[0] && (p.images[0].src || p.images[0]);
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  class BmfCartUpsell extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this.dataset.mobileOnly && window.matchMedia('(min-width: 750px)').matches) return;
      var inCart = (this.dataset.productIds || '').split(',').filter(Boolean).map(Number);
      var limit = parseInt(this.dataset.limit || '4', 10);
      Promise.all([getPool(), getRecs(inCart)]).then(function (res) {
        var pool = res[0], order = res[1];
        var byId = {}; pool.forEach(function (p) { byId[p.id] = p; });
        var ok = function (p) { return p && inCart.indexOf(p.id) < 0 && (p.variants || []).some(function (v) { return v.available; }); };
        var picks = [];
        // 1) Your hand-picked Complementary + Related products (Search & Discovery) for the items in the cart,
        //    most recently added item first, taking turns between cart items so each one is represented.
        var groups = (self.dataset.manual || '').split('|').map(function (g) { return g.split(',').filter(Boolean).map(Number); });
        var manual = [];
        for (var i = 0; groups.some(function (g) { return i < g.length; }); i++) {
          groups.forEach(function (g) { if (i < g.length && manual.indexOf(g[i]) < 0) manual.push(g[i]); });
        }
        manual.forEach(function (id) { if (picks.length < limit && ok(byId[id]) && picks.indexOf(byId[id]) < 0) picks.push(byId[id]); });
        // 2) Shopify's automatic related-product picks, 3) then the rest of the free-shipping collections.
        order.forEach(function (id) { if (picks.length < limit && ok(byId[id]) && picks.indexOf(byId[id]) < 0) picks.push(byId[id]); });
        pool.forEach(function (p) { if (picks.length < limit && ok(p) && picks.indexOf(p) < 0) picks.push(p); });
        if (!picks.length) return;
        self.querySelector('.bmf-up__row').innerHTML = picks.map(function (p) {
          var avail = p.variants.filter(function (v) { return v.available; });
          var single = p.variants.length === 1;
          var v = avail[0];
          var prices = avail.map(function (x) { return parseFloat(x.price); });
          var min = Math.min.apply(null, prices), varies = Math.max.apply(null, prices) > min;
          var title = p.title.replace(/^NEW\s+/i, '');
          var url = root + 'products/' + p.handle;
          return '<div class="bmf-up__card" role="listitem">' +
            (img(p) ? '<a href="' + url + '" tabindex="-1" aria-hidden="true"><img class="bmf-up__img" src="' + esc(img(p)) + '" alt="" loading="lazy" width="64" height="64"></a>' : '') +
            '<div class="bmf-up__info"><a class="bmf-up__title" href="' + url + '">' + esc(title) + '</a>' +
            '<span class="bmf-up__price">' + (varies ? 'From ' : '') + money.format(min) + '</span>' +
            (single ? '<button type="button" class="bmf-up__add" data-variant="' + v.id + '" aria-label="Add ' + esc(title) + ' to cart">Add to cart</button>'
                    : '<a class="bmf-up__add bmf-up__add--opt" href="' + url + '">Choose options</a>') +
            '</div></div>';
        }).join('');
        var h = self.querySelector('.bmf-up__h');
        if (h && picks.length > 1 && !h.querySelector('.bmf-up__hint')) h.insertAdjacentHTML('beforeend', '<span class="bmf-up__hint" aria-hidden="true">Swipe for more \u2192</span>');
        self.hidden = false;
        self.querySelectorAll('button.bmf-up__add').forEach(function (b) { b.addEventListener('click', function () { self.add(b); }); });
      });
    }
    add(btn) {
      var cartItems = document.querySelector('cart-items');
      if (!cartItems || !cartItems.getSectionsToRender) return this.addInPopup(btn);
      var sections = cartItems.getSectionsToRender();
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: sections.map(function (s) { return s.section; }), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (state) {
        if (state.status || !state.sections) { window.location.reload(); return; }
        return added(btn).then(function () { sections.forEach(function (s) {
          var host = document.getElementById(s.id); if (!host || !state.sections[s.section]) return;
          var target = host.querySelector(s.selector) || host;
          target.innerHTML = cartItems.getSectionInnerHTML(state.sections[s.section], s.selector);
        });
        var footer = document.getElementById('main-cart-footer'); if (footer) footer.classList.remove('is-empty');
        });
      }).catch(function () { window.location.reload(); });
    }
  }
  BmfCartUpsell.prototype.addInPopup = function (btn) {
    var ids = ['bmf-free-ship', 'cart-notification-button', 'cart-icon-bubble'];
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: ids, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status || !state.sections) { btn.textContent = 'Sold out'; return; }
      return added(btn).then(function () { ids.forEach(function (id) {
        var host = document.getElementById(id); if (!host || !state.sections[id]) return;
        var src = new DOMParser().parseFromString(state.sections[id], 'text/html').querySelector('.shopify-section');
        if (src) host.innerHTML = src.innerHTML;
      }); });
    }).catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
  };
  customElements.define('bmf-cart-upsell', BmfCartUpsell);

  // Free-shipping codes attached to the cart (e.g. from a /discount/CODE link) don't change the cart total,
  // so the bar can't see them in Liquid. If an applied code isn't used by any product/order discount,
  // it is a shipping discount: show that the code includes free shipping.
  var shipBusy = false;
  function shipCheck() {
    if (shipBusy || !document.querySelector('.bmf-fs:not([data-bmf-code])')) return;
    shipBusy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var used = {};
      (cart.cart_level_discount_applications || []).forEach(function (a) { used[a.title] = 1; });
      (cart.items || []).forEach(function (i) {
        (i.discounts || []).forEach(function (d) { used[d.title] = 1; });
        (i.line_level_discount_allocations || []).forEach(function (d) { if (d.discount_application) used[d.discount_application.title] = 1; });
      });
      var code = (cart.discount_codes || []).filter(function (d) { return d.applicable && !used[d.code]; })[0];
      document.querySelectorAll('.bmf-fs:not([data-bmf-code])').forEach(function (bar) {
        bar.setAttribute('data-bmf-code', code ? code.code : '');
        if (!code) return;
        bar.classList.add('bmf-fs--done');
        var msg = bar.querySelector('.bmf-fs__msg'); if (msg) msg.innerHTML = '<strong>Your code ' + esc(code.code) + ' includes FREE shipping!</strong>';
        var fill = bar.querySelector('.bmf-fs__fill'); if (fill) fill.style.width = '100%';
        var note = bar.querySelector('.bmf-fs__note'); if (note) note.remove();
      });
    }).catch(function () {}).then(function () { shipBusy = false; });
  }
  var shipTimer;
  new MutationObserver(function () { clearTimeout(shipTimer); shipTimer = setTimeout(shipCheck, 250); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shipCheck); else shipCheck();
})();
